import { ThreeDotsDropdownV3 } from "@circle-react-shared/ThreeDotsDropdownV3";
import { Dropdown } from "@circle-react-uikit/Dropdown";
import { t } from "@/i18n-js/instance";

interface UpsellActionsProps {
  offeredPaywallStatus: string;
}

export const UpsellActions = ({ offeredPaywallStatus }: UpsellActionsProps) => (
  <ThreeDotsDropdownV3 label={t("actions")}>
    <Dropdown.ItemWithLink onClick={() => {}} linkType="button">
      {t("preview")}
    </Dropdown.ItemWithLink>
    {offeredPaywallStatus !== "disabled" && (
      <Dropdown.ItemWithLink onClick={() => {}} linkType="button">
        {t("disable")}
      </Dropdown.ItemWithLink>
    )}
    {offeredPaywallStatus !== "enabled" && (
      <Dropdown.ItemWithLink onClick={() => {}} linkType="button">
        {t("enable")}
      </Dropdown.ItemWithLink>
    )}
    <Dropdown.ItemWithLink onClick={() => {}} linkType="button">
      {t("remove")}
    </Dropdown.ItemWithLink>
  </ThreeDotsDropdownV3>
);
